<template>
  <div dense class="pa-2" style="border-right: solid 1px lightgray">
    <v-subheader>Mã Sách</v-subheader>
    <v-text-field
      v-model="code"
      deletable-chips
      clear-icon="mdi-close"
      clearable
      @change="onFilterChanged"
      label="Mã Sách"
      outlined
      dense
      :required="false"
    ></v-text-field>
    <v-divider></v-divider>
    <v-subheader>Bộ Lọc</v-subheader>
    <v-autocomplete
      :items="allBookStatus"
      v-model="status"
      item-text="title"
      item-value="status"
      deletable-chips
      clear-icon="mdi-close"
      clearable
      chips
      small-chips
      label="Trạng Thái"
      single
      outlined
      dense
    ></v-autocomplete>
    <v-divider></v-divider>

    <v-subheader>Thời gian Mượn</v-subheader>
    <v-radio-group v-model="time" style="with: 100%">
      <div class="pa-4">
        <v-radio label="Hôm Nay" :value="today"></v-radio>
        <v-radio label="Tuần Này" :value="week"></v-radio>
        <v-radio label="Tháng Này" :value="month"></v-radio>
        <v-radio label="Tất Cả" :value="all"></v-radio>
      </div>
    </v-radio-group>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed small color="primary" @click="onFilterChanged">
        <v-icon left dark>mdi-magnify</v-icon>Lọc
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  props: {
    defaultFilters: Object
  },
  data: () => ({
    query: '',
    status: '',
    code: '',
    time: null,
    checkbox: false,
    today: {
      date_gt: moment()
        .startOf('day')
        .toISOString()
    },
    all: {},
    month: {
      date_gt: moment()
        .startOf('month')
        .toISOString(),
      date_lt: moment()
        .endOf('month')
        .toISOString()
    },
    week: {
      date_gt: moment()
        .startOf('week')
        .toISOString(),
      date_lt: moment()
        .endOf('week')
        .toISOString()
    }
  }),
  computed: {
    ...mapState('constant', ['bookStatus', 'bookTypes']),
    allBookStatus () {
      return [
        {
          title: 'Tất Cả',
          status: ''
        },
        ...this.bookStatus
      ]
    },
    allBookType () {
      return [
        {
          title: 'Tất Cả',
          status: ''
        },
        ...this.bookTypes
      ]
    }
  },
  created () {},
  methods: {
    onFilterChanged () {
      this.$emit('onFilterChanged', {
        code_contains: this.code,
        status: this.status,
        ...this.time,
        type: 'book'
      })
    }
  }
}
</script>
<style scoped>
.v-input--selection-controls,
.v-input__slot {
  margin: 0;
  padding: 0;
}
</style>
